import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import * as MobileActions from 'actions/index.ts';
import { Link, Redirect } from 'react-router-dom';
import { Toast } from 'react-weui';
import { withStyles } from '@material-ui/core/styles';
import Http from 'services/http2';
import User from 'services/user2';
import Storage from 'services/storage2';
import Company from 'components/company';
import VerifyPartner from 'components/verifyPartner';
import EmployeeJoin from 'components/employeeJoin';

import Avatar from '@material-ui/core/Avatar';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemAvatar from '@material-ui/core/ListItemAvatar';
import ListItemText from '@material-ui/core/ListItemText';
import DialogTitle from '@material-ui/core/DialogTitle';
import Dialog from '@material-ui/core/Dialog';
import PersonIcon from '@material-ui/icons/Person';
import Util from 'lib/util';

import Drawer from '@material-ui/core/Drawer';
import IconButton from '@material-ui/core/IconButton';
import MenuIcon from '@material-ui/icons/Menu';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import BallotIcon from '@material-ui/icons/Ballot';

const Sortable = window['Sortable'];

/* dev
http://open.weixin.qq.com/connect/oauth2/authorize?appid=wxf3cf604fbe16e419&redirect_uri=https%3A%2F%2Fdev.xiekeyun.com%2Fmp%2Fworkbench&response_type=code&scope=snsapi_base&state=123#wechat_redirect
*/

const styles = theme => ({
  root: {
    marginTop: 20,
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'space-around',
    overflow: 'hidden',
    backgroundColor: theme.palette.background.paper,
  },
  icon: {
    fontSize: 48,
  },
  avatar: {
    backgroundColor: '#bbdefb',
    color: '#1e88e5',
  },
  listItem: {
    marginBottom: '10px',
    padding: '8px 24px',
  },
  menuButton: {
    paddingBottom: 0,
    paddingTop: 0,
  },
});

// const shortcutRoutes = [
//   {
//     text: '设置微信消息',
//     path: '/mp/message/setup',
//   },
//   {
//     text: '设置用户信息',
//     path: '/mp/personal',
//   },
// ];

const purchsRoutes = [
  {
    // text: '供应商管理',
    menuCode: '100501',
    authCode: '10050101',
    path: '/mp/purchase/supplier/list',
    icon: '100501.png',
  },
  {
    // text: '潜在供应商',
    menuCode: '100901',
    authCode: '10090101',
    path: '/mp/purchase/sourcing/list',
    icon: '100901.png',
  },
  {
    // text: '采购订单',
    menuCode: '100101',
    authCode: '10010101',
    path: '/mp/purchase/order/list',
    icon: '100101.png',
  },
  {
    // text: '采购变更',
    menuCode: '100102',
    authCode: '10010201',
    path: '/mp/purchase/change/list',
    icon: '100102.png',
  },
  {
    // text: '请购单',
    menuCode: '100108',
    authCode: '10010801',
    path: '/mp/purchase/requisition/list',
    icon: '100108.png',
  },
  {
    // text: '送货通知',
    menuCode: '100301',
    authCode: '10030101',
    path: '/mp/purchase/vendorDelivery/list',
    icon: '100301.png',
  },
  {
    // text: '收货/入库',
    menuCode: '100302',
    authCode: '10030201',
    path: '/mp/purchase/receive/list',
    icon: '100302.png',
  },
  {
    text: '分析报表',
    menuCode: '100104',
    authCode: '10010401',
    path: '/mp/statistics/purchase/order',
    icon: '100104.png',
  },
  {
    text: '询价招标',
    menuCode: '100503',
    authCode: '10050301',
    path: '/mp/purchase/inquiry/prod/list',
    icon: '100503.png',
  },
  {
    // text: '竞价',
    menuCode: '100703',
    authCode: '10070301',
    path: '/mp/purchase/inquiry/bid/list',
    icon: '100703.png',
  },
  {
    text: '多物料竞价',
    menuCode: '100706',
    authCode: '10070601',
    path: '/mp/purchase/inquiry/bid-multi/list',
    icon: '100706.png',
  },
  {
    text: '物流竞价',
    menuCode: '100709',
    authCode: '10070901',
    path: '/mp/purchase/inquiry/bid/freightage/list',
    icon: '100709.png',
  },
  {
    // text: '核价单',
    menuCode: '100708',
    authCode: '10070801',
    path: '/mp/purchase/pricing/list',
    icon: '100708.png',
  },
  {
    // text: '工序核价单',
    menuCode: '100717',
    authCode: '10071701',
    path: '/mp/purchase/pricing/process/list',
    icon: '100708.png',
  },
  {
    // text: '比价单',
    menuCode: '100710',
    authCode: '10071001',
    path: '/mp/purchase/inquiry/quote-compare/list',
    icon: '100710.png',
  },
  // {
  //   // text: '管理报表',
  //   menuCode: '100104',
  //   authCode: '10010401',
  //   path: '/mp/statistics/purchase/monthlyReport/list',
  //   icon: '100104_2.png'
  // },
  {
    // text: '订单进度',
    menuCode: '100103',
    authCode: '10010301',
    path: '/mp/purchase/order/report/list',
    icon: '100103.png',
  },
  {
    text: '直运看板',
    menuCode: '100204',
    authCode: '10020401',
    path: '/mp/purchase/plan/tpp/board',
    icon: '100204.png',
  },
  {
    // text: '供应商通知',
    menuCode: '100505',
    authCode: '10050501',
    path: '/mp/notify/list/2',
    icon: '100505.png',
  },
  {
    text: '对账单',
    menuCode: '100401',
    authCode: '10040101',
    path: '/mp/purchase/billing/statement/list',
    icon: '100401.png',
  },
  {
    text: '费用通知',
    menuCode: '100404',
    authCode: '10040401',
    path: '/mp/purchase/billing/cost/list',
    icon: '100404.png',
  },
  {
    text: '发票通知',
    menuCode: '100402',
    authCode: '10040201',
    path: '/mp/purchase/billing/invoice/list',
    icon: '100402.png',
  },
  {
    // text: '物料准入报告',
    menuCode: '100512',
    authCode: '10051201',
    path: '/mp/purchase/supplier/buyoff-report/list',
    icon: '100512.png',
  },
  {
    // text: '来料检验单',
    menuCode: '100801',
    authCode: '10080101',
    path: '/mp/purchase/iqc/list',
    icon: '100801.png',
  },
  {
    // text: '8D报告',
    menuCode: '100805',
    authCode: '10080501',
    path: '/mp/purchase/iqc/8d-report/list',
    icon: '100805.png',
  },
  {
    text: 'ECN报告',
    menuCode: '100516',
    authCode: '10051601',
    path: '/mp/purchase/ecn/list',
    icon: '100516.png',
  },
  {
    // text: '物料档案',
    menuCode: '300304',
    authCode: '30030401',
    path: '/mp/management/basic-data/prod/list',
    icon: '300304.png',
  },
  {
    // text: '供应商准入评估',
    menuCode: '100903',
    authCode: '10090301',
    path: '/mp/purchase/supplier/assessment-report/list',
    icon: '100903.png',
  },
  {
    text: '交料通知',
    menuCode: '100105',
    authCode: '10010501',
    path: '/mp/purchase/delivery-change/list',
    icon: '100105.png',
  },
  {
    // text: '供应计划排程',
    menuCode: '100202',
    authCode: '10020201',
    path: '/mp/purchase/plan/schedule/list',
    icon: '100202.png',
  },
  {
    // text: '内部商城引入单',
    menuCode: '100904',
    authCode: '10090401',
    path: '/mp/purchase/mall/introduce-list',
    icon: '100904.png',
  },
  // {
  //   // text: '企业内部商城',
  //   menuCode: '100905',
  //   authCode: '10090501',
  //   path: '/mp/purchase/mall/prod-list',
  //   icon: '100904.png'
  // },
  {
    // text: '付款单',
    menuCode: '100403',
    authCode: '10040301',
    path: '/mp/purchase/payment/order/list',
    icon: '100403.png',
  },
  {
    // text: '供应商违约/索赔通知',
    menuCode: '100518',
    authCode: '10051801',
    path: '/mp/purchase/supplier/penalty-notice/list',
    icon: '100518.png',
  },
  {
    // text: '付款申请',
    menuCode: '100406',
    authCode: '10040601',
    path: '/mp/purchase/payment/apply/list',
    icon: '100406.png',
  },
  {
    // text: '项目招标',
    menuCode: '100713',
    authCode: '10071301',
    path: '/mp/purchase/inquiry/project/ifb/list',
    icon: '100713.png',
  },
  {
    // text: '询价需求',
    menuCode: '100705',
    authCode: '10070501',
    path: '/mp/purchase/inquiry/inner/list',
    icon: '100705.png',
  },
  {
    // text: '采购验收',
    menuCode: '100312',
    authCode: '10031203',
    path: '/mp/purchase/receive/acceptance/list',
    icon: '100312.png',
  },
  {
    text: '退出管理',
    menuCode: '100519',
    authCode: '10051901',
    path: '/mp/purchase/supplier/terminate/list',
    icon: '100519.png',
  },
  {
    text: '信息变更',
    menuCode: '100520',
    authCode: '10052001',
    path: '/mp/purchase/supplier/info-change/list',
    icon: '100520.png',
  },
  {
    // text: '延迟送货申请',
    menuCode: '100304',
    authCode: '10030401',
    path: '/mp/purchase/delivery-delay/list',
    icon: '100304.png',
  },
  {
    text: '预付款单',
    menuCode: '100410',
    authCode: '10041001',
    path: '/mp/purchase/payment/advance/list',
    icon: '100410.png',
  },
];

const saleRoutes = [
  {
    // text: '客户订单',
    menuCode: '200101',
    authCode: '20010101',
    path: '/mp/sale/customer/order/list',
    icon: '200101.png',
  },
  {
    // text: '客户变更',
    menuCode: '200102',
    authCode: '20010101',
    path: '/mp/sale/customer/change/list',
    icon: '200102.png',
  },
  {
    // text: '送货通知',
    menuCode: '200301',
    authCode: '20030101',
    path: '/mp/sale/delivery/list',
    icon: '200301.png',
  },
  {
    text: '询价招标',
    menuCode: '200503',
    authCode: '20050301',
    path: '/mp/sale/inquiry/prod/list',
    icon: '200503.png',
  },
  {
    // text: '竞价',
    menuCode: '200703',
    authCode: '20070301',
    path: '/mp/sale/inquiry/bid/list',
    icon: '200703.png',
  },
  {
    text: '多物料竞价',
    menuCode: '200704',
    authCode: '20070401',
    path: '/mp/sale/inquiry/bid-multi/list',
    icon: '200704.png',
  },
  {
    text: '物流竞价',
    menuCode: '200705',
    authCode: '20070501',
    path: '/mp/sale/inquiry/bid/freightage/list',
    icon: '200705.png',
  },
  {
    // text: '订单进度',
    menuCode: '200103',
    authCode: '20010301',
    path: '/mp/sale/customer/report/list',
    icon: '200103.png',
  },
  {
    text: '直运看板',
    menuCode: '200204',
    authCode: '20020401',
    path: '/mp/sale/plan/tpp/board',
    icon: '200204.png',
  },
  {
    // text: '客户通知',
    menuCode: '200505',
    authCode: '20050501',
    path: '/mp/notify/list/1',
    icon: '200505.png',
  },
  {
    text: '对账单',
    menuCode: '200401',
    authCode: '20040101',
    path: '/mp/sale/billing/statement/list',
    icon: '200401.png',
  },
  {
    text: '费用通知',
    menuCode: '200403',
    authCode: '20040301',
    path: '/mp/sale/billing/cost/list',
    icon: '200403.png',
  },
  {
    text: '发票通知',
    menuCode: '200402',
    authCode: '20040201',
    path: '/mp/sale/billing/invoice/list',
    icon: '200402.png',
  },
  {
    // text: '物料准入报告',
    menuCode: '200510',
    authCode: '20051001',
    path: '/mp/sale/customer/buyoff-report/list',
    icon: '200510.png',
  },
  {
    text: '检验不良',
    menuCode: '200305',
    authCode: '20030501',
    path: '/mp/sale/customer/iqc/list',
    icon: '200305.png',
  },
  {
    // text: '8D报告',
    menuCode: '200310',
    authCode: '20031001',
    path: '/mp/sale/customer/iqc/8d-report/list',
    icon: '200310.png',
  },
  {
    // text: '商机线索',
    menuCode: '200802',
    authCode: '20080201',
    path: '/mp/sale/opportunity-management/lead/list',
    icon: '200802.png',
  },
  {
    text: 'ECN报告',
    menuCode: '200512',
    authCode: '20051201',
    path: '/mp/sale/ecn/list',
    icon: '200512.png',
  },
  {
    // text: '客户准入评估',
    menuCode: '200803',
    authCode: '20080301',
    path: '/mp/sale/customer/assessment-report/list',
    icon: '200803.png',
  },
  {
    text: '交料通知',
    menuCode: '200104',
    authCode: '20010401',
    path: '/mp/sale/delivery-change/list',
    icon: '200104.png',
  },
  {
    // text: '客户交货排程',
    menuCode: '200202',
    authCode: '20020201',
    path: '/mp/sale/plan/schedule/list',
    icon: '200202.png',
  },
  {
    // text: '供应商违约/索赔通知',
    menuCode: '200513',
    authCode: '20051301',
    path: '/mp/sale/customer/penalty-notice/list',
    icon: '200513.png',
  },
  {
    // text: '付款申请',
    menuCode: '200407',
    authCode: '20040701',
    path: '/mp/sale/cust-payment/apply/list',
    icon: '200407.png',
  },
  {
    // text: '项目招标',
    menuCode: '200706',
    authCode: '20070601',
    path: '/mp/sale/inquiry/project/ifb/list',
    icon: '200706.png',
  },
  {
    // text: '企业信息变更',
    menuCode: '200514',
    authCode: '20051401',
    path: '/mp/sale/customer/my-info-change/list',
    icon: '200514.png',
  },
  {
    // text: '延迟送货申请',
    menuCode: '200304',
    authCode: '20030401',
    path: '/mp/sale/delivery-delay/list',
    icon: '200304.png',
  },
  {
    text: '预付款单',
    menuCode: '200409',
    authCode: '20040901',
    path: '/mp/sale/cust-payment/advance/list',
    icon: '200409.png',
  },
  {
    // text: '客供料代收',
    menuCode: '200313',
    authCode: '20031301',
    path: '/mp/sale/customer-receive/asn/list',
    icon: '200313.png',
  },
  {
    // text: '客户退货',
    menuCode: '200303',
    authCode: '20030301',
    path: '/mp/sale/delivery/return/list',
    icon: '200303.png',
  },
  {
    // text: '客户问卷',
    menuCode: '200509',
    authCode: '20050901',
    path: '/mp/sale/customer/questionnaire/list',
    icon: '300304.png',
  },
];

// const managementRoutes = [];
// 抽屉菜单
const drawerRoutes = [
  { text: '设置微信消息', path: '/mp/message/setup', icon: <BallotIcon /> },
  { text: '设置用户信息', path: '/mp/personal', icon: <BallotIcon /> },
];

const drawerList = (
  <div>
    <List>
      {drawerRoutes.map((route, index) => (
        <ListItem button component="a" key={index} href={route.path}>
          <ListItemIcon>{route.icon}</ListItemIcon>
          <ListItemText primary={route.text} />
        </ListItem>
      ))}
    </List>
  </div>
);

const Config = {
  sale: {
    apiPath: '/main/cusAnswerPlanRate',
    items: [
      { label: '答交准时率', code: 'cusAnswerTimeRate' },
      { label: '答交满足率', code: 'cusAnswerStatusRate' },
      { label: '计划满足率', code: 'cusPlanRate' },
    ],
    menuConfig: {
      9000: {
        menuName: '接受客户邀请',
        authCode: '20050107',
      },
      9100: {
        menuName: '员工加入公司',
      },
    },
  },
  purchase: {
    apiPath: '/main/answerPlanRate',
    items: [
      { label: '供应商答交准时率', code: 'answerTimeRate' },
      { label: '供应商答交满足率', code: 'answerStatusRate' },
      { label: '供应商计划满足率', code: 'planRate' },
    ],
    menuConfig: {
      9100: {
        menuName: '员工加入公司',
      },
      // 9101: {
      //   menuName: '管理报表',
      //   path: '/mp/statistics/purchase/monthlyReport/list',
      // }
    },
  },
};

/* dev
https://open.weixin.qq.com/connect/oauth2/authorize?appid=wxf3cf604fbe16e419&redirect_uri=http%3A%2F%2Fdev.xiekeyun.com%2Fmp%2Fworkbench&response_type=code&scope=snsapi_base&state=123#wechat_redirect
*/

class WorkBench extends Component {
  constructor(props) {
    super(props);
    this.state = {
      inited: false,
      isDebug: false,
      error: null,
      showToast: false,
      showLoading: false,
      showError: false,
      showRoleSetup: false,
      showReceiveInvite: false,
      showSuccess: false,
      data: {},
      list: [],
      mpMenuList: [],
      config: {
        items: [],
      },
      cpCode: '',
      inviteErrorMsg: '',
      inviteCode: '',
      inviteCompanyCode: '',
      companyList: [],
      waitWorksCount: 0, //待处理任务数量
      waitFollowCount: 0, //待跟进任务数量
      approvedNum: 0, //待审批任务数量
      roleType: 1, //1采购，2销售
      shortcuts: [], //常用功能
      open: false, //常用功能展开状态
      reRender: false, //重新渲染页面
      menuSort: false, //菜单排序
      showDrawerMenu: false,
    };
    this.menuList = [];
    this.dialogMsg = '';
    this.companyCode = '';
    this.errorMsg = '';
    this.toastTimer = null;
    this.loadingTimer = null;
    this.errorTimer = null;
    this.type = 'sale';
    this.menuSort = false;
    this.objMenuCodes = {};
    this.userInfo = {};
    this.sortable = null;
    this.isComponentWillUnmount = false;
    this.timer = null;
    this.pendingConfigJson = { 1: true, 2: true, 3: true }; //工作台待办配置默认全选
    this.handleCompanyChange = this.handleCompanyChange.bind(this);
    this.handleModalChange = this.handleModalChange.bind(this);
  }

  init() {
    User.init(this.companyCode).then(async response => {
      if (response.success) {
        this.companyCode = User.getCompanyCode();
        let companyList = User.getCompanyList();
        this.setState({ companyList: companyList });
        if (this.companyCode === null) {
          this.props.history.push('/mp/index');
          return;
        }
        this.setState({ inited: true });
        // this.getPartnerInfo();
        // this.handleSetupRole();
        //用于隐藏调试用入口
        this.userInfo = User.getUserInfo();
        if (this.userInfo && this.userInfo.id < 11) {
          this.setState({ isDebug: true });
        }
        this.getMenuList(this.userInfo.id);
        //监听滚动事件，并缓存滚动高度，便于返回工作台时回到原位置
        window.addEventListener('scroll', () => {
          if (this.isComponentWillUnmount === true) {
            return;
          }
          if (this.timer) {
            clearTimeout(this.timer);
          }
          this.timer = setTimeout(() => {
            Storage.setItem('wbHistoryState', {
              scrollTop: document.documentElement.scrollTop,
            });
          }, 100);
        });
      } else {
        this.props.history.push('/mp/index');
      }
    });

    document.getElementById('root').style.paddingBottom = '0px';
  }

  componentDidMount() {
    this.init();
  }

  errorFn(errorMsg) {
    this.errorMsg = errorMsg;
    this.setState({ showLoading: false });
    this.setState({ showError: true });
    this.errorTimer = setTimeout(() => {
      this.setState({ showError: false });
    }, 3000);
  }

  componentWillUnmount() {
    this.isComponentWillUnmount = true;
    if (this.toastTimer) {
      clearTimeout(this.toastTimer);
    }
    if (this.loadingTimer) {
      clearTimeout(this.loadingTimer);
    }
    if (this.errorTimer) {
      clearTimeout(this.errorTimer);
    }
    if (this.timer) {
      clearTimeout(this.timer);
    }
  }

  //设置默认角色（我是采购/销售）
  handleSetupRole() {
    if (!User.getCompanyInfo().roleCode) {
      User.getUserInfoByToken().then(data => {
        if (data && data.companyList.length) {
          let defaultCompany =
            data.companyList.filter(item => item.defaultFlag === 1)[0] || {};
          let roleCode = defaultCompany.roleCode;
          if (!roleCode) {
            let postbody = {
              companyCode: this.companyCode,
              inviteStatus: 2,
              apiPath: '/archives/compEmployee/getCountByCompCode',
            };
            Http.post('/api/cloudCenter', postbody).then(response => {
              if (response.success && response.data === 1) {
                //设置权限
                this.setState({ showRoleSetup: true });
              }
            });
          }
        }
      });
    }
  }

  handleRole(role) {
    let postbody = {
      companyCode: this.companyCode,
      userId: User.getUserInfo().id,
      sourceType: role,
      apiPath: '/archives/compEmployee/selectType',
    };
    Http.post('/api/cloudCenter?btnId=001', postbody).then(response => {
      this.setState({ showRoleSetup: false });
      if (response.success && !response.errorMsg) {
        User.refreshUserInfo();
        this.setState({ showToast: true });
        setTimeout(() => {
          window.location.reload();
        }, 3000);
      } else {
        this.errorFn(response.errorMsg);
      }
    });
  }

  handleShortcutClick(route) {
    const { actions } = this.props;
    //接受客户邀请
    if (route.id === 9000) {
      actions.openVerifyPartnerModal();
    }
    //员工加入公司
    if (route.id === 9100) {
      actions.openEmployeeJoinModal();
    }
  }

  //获取菜单红点
  async getMenuMark() {
    let res;
    let postbody = {
      companyCode: this.companyCode,
      apiPath: '/main/menuMark',
    };
    await Http.post('/api/cloudCenter', postbody).then(response => {
      if (response.success) {
        res = response.data;
      }
    });
    return res;
  }

  //获取菜单列表
  getMenuList(userId) {
    User.queryTreeOnly().then(async res => {
      if (Array.isArray(res)) {
        this.menuList = res;
        await this.userPreferenceDetail(userId, res);
        await this.getMenuSort(userId);
        this.getMpMenuList();
        //获取缓存的滚动条高度
        let wbHistoryState = Storage.getItem('wbHistoryState');
        if (wbHistoryState) {
          document.documentElement.scrollTop = wbHistoryState.scrollTop || 0;
        }
      }
    });
  }

  //常用功能
  async userPreferenceDetail(objCode, menuList) {
    let functionConfig = {
      1: [10, 15, 16, 13, 9001],
      2: [37, 42, 43, 40, 9000],
    }; //默认常用功能配置
    let config = Config['purchase'];
    let menus = purchsRoutes;
    let postbody = {
      objCode: objCode,
      objType: 1,
      contentType: '2',
      apiPath: '/userSetting/userPreferenceDetail',
    };
    this.setState({ showLoading: true });
    await Http.post('/api/cloudCenter', postbody).then(response => {
      if (response.success && response.data) {
        let obj = Util.jsonDecode(response.data.contentJson) || {};
        let menuIds = [];
        let shortcuts = [];

        functionConfig = obj.functionConfigJson;
        if (!Util.isEmpty(functionConfig)) {
          menuIds = functionConfig[obj.roleType || 1];
        }
        menuIds = menuIds.concat([9100]); //工作台改造前原有的固定快捷入口

        if (obj.roleType === 2) {
          config = Config['sale'];
          menus = saleRoutes;
        }
        if (!Util.isEmpty(menuList)) {
          menuList.forEach(menu => {
            let fn = subMenuList => {
              subMenuList.forEach(children => {
                if (menuIds.includes(children.id)) {
                  menus.some(item => {
                    //过滤有页面的常用功能
                    if (
                      item.menuCode === children.menuCode &&
                      User.checkAuth(item.authCode)
                    ) {
                      let shortcutItem = {
                        ...children,
                        ...item,
                      };
                      shortcuts.push(shortcutItem);
                    }
                    return item.menuCode === children.menuCode;
                  });
                } else if (
                  Array.isArray(children.subMenuList) &&
                  children.subMenuList.length
                ) {
                  fn(children.subMenuList);
                }
              });
            };
            fn(menu.subMenuList);
          });
          //非链接类的常用功能
          if (Array.isArray(menuIds)) {
            menuIds.forEach(id => {
              if (id > 8999 && config.menuConfig[id]) {
                let menuName = config.menuConfig[id].menuName;
                shortcuts.push({ id: id, menuName: menuName });
              }
            });
          }
          //工作台改造前原有的固定快捷入口
          // shortcuts = shortcuts.concat(
          //   shortcutRoutes.map(route => {
          //     return { menuName: route.text, path: route.path };
          //   })
          // );
          //管理报表
          shortcuts = this.updateShortcuts(shortcuts);
        }
        if (obj.pendingConfigJson) {
          this.pendingConfigJson = obj.pendingConfigJson;
        }
        this.setState({ roleType: obj.roleType || 1, shortcuts: shortcuts });
      }
    });
    //待审批任务数量
    if (this.pendingConfigJson) {
      if (this.pendingConfigJson[1] || this.pendingConfigJson[2]) {
        this.getMainBillCount();
      }
      if (this.pendingConfigJson[3]) {
        this.getStayTasksApprovedNum();
      }
    } else {
      //未设置，默认需调用
      this.getMainBillCount();
      this.getStayTasksApprovedNum();
    }
    this.setState({ showLoading: false });
  }

  updateShortcuts(shortcuts) {
    let arr = [];
    if (Array.isArray(shortcuts)) {
      arr = shortcuts.slice(0);
      let adminReportFlag = 0;
      this.state.companyList.some(item => {
        if (this.companyCode === item.companyCode) {
          adminReportFlag = item.adminReportFlag;
        }
        return this.companyCode === item.companyCode;
      });
      if (adminReportFlag === 1) {
        if (!arr.some(row => row.id === 9101)) {
          arr.push({
            id: 9101,
            menuName: '管理报表',
            path: '/mp/statistics/purchase/monthlyReport/list',
          });
        }
      } else if (arr.some(row => row.id === 9101)) {
        arr = arr.filter(row => !row.id || row.id !== 9101);
      }
      //图标
      arr.forEach((row, i) => {
        let index = i + 1;
        index = index > 5 ? 5 : index;
        row.icon = '/assets/img/mp/shortcut_icon_' + index + '@2x.png';
      });
    }
    return arr;
  }

  //获取排序
  async getMenuSort(objCode) {
    let postbody = {
      objCode: objCode,
      objType: 1,
      contentType: '7',
      apiPath: '/userSetting/userPreferenceDetail',
    };
    this.setState({ showLoading: true });
    await Http.post('/api/cloudCenter', postbody).then(response => {
      if (response.success) {
        if (response.data && response.data.contentJson) {
          this.objMenuCodes = Util.jsonDecode(response.data.contentJson) || {};
        }
      }
    });
    this.setState({ showLoading: false });
  }

  //保存排序，contentType的定义在携客云'core/custom-types'
  async menuSortSave() {
    let postbody = {
      objCode: User.getUserInfo().id,
      objType: 1,
      contentType: '7', //7：微信工作台菜单排序
      contentJson: JSON.stringify(this.objMenuCodes),
      apiPath: '/userSetting/userPreferenceSave',
    };
    await Http.post('/api/cloudCenter', postbody).then(response => {
      if (response.success) {
        this.setState({ showSuccess: true, menuSort: false });
        setTimeout(() => {
          this.setState({ showSuccess: false });
          window.location.reload();
        }, 2000);
      } else {
        this.errorFn(response.errorMsg);
      }
    });
  }

  //根据菜单列表组装微信菜单
  getMpMenuList() {
    let mpMenuList = [];
    let menus = this.state.roleType === 1 ? purchsRoutes : saleRoutes;
    let arrMenuCodes = this.objMenuCodes[this.state.roleType] || [];

    if (Array.isArray(this.menuList)) {
      this.menuList.forEach(item => {
        if (Array.isArray(item.subMenuList)) {
          item.subMenuList.forEach(row => {
            if (
              Array.isArray(row.subMenuList) &&
              row.subMenuList.some(sub =>
                menus.some(o => o.menuCode === sub.menuCode)
              )
            ) {
              let obj = {
                menuCode: row.menuCode,
                menuName: row.menuName,
                isOn: true,
                subMenuList: [],
              };
              row.subMenuList.forEach(sub => {
                menus.some(o => {
                  if (o.menuCode === sub.menuCode) {
                    obj.subMenuList.push({
                      ...sub,
                      ...o,
                      menuName: o.text || sub.menuName,
                      sort: User.checkAuth(o.authCode) ? sub.sortNum : 99999, //99999表示无权限，配合view使用
                      icon: o.icon
                        ? '/assets/img/mp/icon/' + o.icon
                        : '/assets/img/mp/icon@2x.png',
                    });
                  }
                  return o.menuCode === sub.menuCode;
                });
              });
              //有权限靠前，无权限置灰靠后
              obj.subMenuList.sort((a, b) => a.sort - b.sort);
              mpMenuList.push(obj);
            }
          });
        }
      });
    }
    //根据用户偏好排序
    this.sortMenuList(arrMenuCodes, mpMenuList);
    this.setState({ mpMenuList: mpMenuList });
    //获取菜单红点
    this.getMenuMark().then(res => {
      if (Array.isArray(res)) {
        mpMenuList.forEach(item => {
          if (Array.isArray(item.subMenuList)) {
            item.subMenuList.forEach(row => {
              row.menuMark = res.some(menuCode => menuCode === row.menuCode);
            });
          }
        });
        this.setState({ mpMenuList: mpMenuList });
      }
    });
  }

  sortMenuList(arrMenuCodes, mpMenuList) {
    if (arrMenuCodes.length) {
      mpMenuList.forEach(menu => {
        menu.sort = undefined;
        arrMenuCodes.some((code, idx) => {
          if (menu.menuCode === code) {
            menu.sort = idx + 1;
          }
          return menu.menuCode === code;
        });
      });
      mpMenuList.sort((a, b) => a.sort - b.sort);
    }
  }

  handleOnOff() {
    let isOpen = !this.state.open;
    this.setState({ open: isOpen });
  }

  handleMore(item) {
    item.isOn = !item.isOn;
    this.setState({ reRender: true });
  }

  handleTab(type) {
    this.setState({ roleType: type });
    setTimeout(() => {
      this.getMpMenuList();
    }, 100);
  }

  handleSort() {
    let menuSort = this.state.menuSort;
    this.setState({ menuSort: !menuSort });
    setTimeout(() => {
      if (!this.state.menuSort) {
        this.sortable.destroy();
        this.sortable = null;
      } else {
        this.createSortable();
      }
    }, 0);
  }

  handleSortUpdate(type) {
    if (type === 'save') {
      // 保存
      this.menuSortSave();
    } else {
      // 取消
      this.setState({ menuSort: false });
      setTimeout(() => {
        this.sortable.destroy();
        this.sortable = null;
      }, 0);
    }
  }

  //创建排序列表
  createSortable() {
    // if (this.sortable !== null) {
    //   this.sortable.destroy();
    // }
    let mpMenuList = this.state.mpMenuList.slice(0);
    this.sortable = new Sortable(document.querySelector('.drag-drop-wrap'), {
      // options here
      animation: 150,
      // Element dragging ended
      onEnd: e => {
        let delItem = mpMenuList.splice(e.oldIndex, 1);
        mpMenuList.splice(e.newIndex, 0, ...delItem);
        this.objMenuCodes[this.state.roleType] = mpMenuList.map(
          item => item.menuCode
        );
      },
    });
  }

  //重要指标--统计
  getMainBillCount() {
    let postbody = {
      companyCode: this.companyCode,
      userId: this.userInfo.id,
      onlyPreferenceBillType: 0,
      apiPath: '/main/waitBillCount',
    };
    Http.post('/api/cloudCenter', postbody).then(response => {
      if (response.success) {
        let data = response.data;
        if (data) {
          this.setState({
            waitWorksCount: data.waitWorksCount || 0,
            waitFollowCount: data.waitFollowCount || 0,
          });
        }
      }
    });
  }

  //在线协同总供应商/总客户
  getPartnerInfo() {
    let postbody = {
      companyCode: this.companyCode,
      apiPath: '/archives/compVendor/getPartnerInfo',
    };
    Http.post('/api/cloudCenter', postbody).then(response => {
      if (response.success) {
        let data = response.data;
        if (data['allVendorCount'] > data['allCustomerCount']) {
          this.type = 'purchase';
        } else {
          this.type = 'sale';
        }
        this.getPlanRate(Config[this.type].apiPath);
      }
    });
  }

  //获取统计数据
  getPlanRate(apiPath) {
    let postbody = {
      action: 'month',
      companyCode: this.companyCode,
      apiPath,
    };
    Http.post('/api/cloudCenter', postbody).then(response => {
      if (response.success) {
        let data = response.data;
        let role = Config[this.type];
        role.items.forEach(item => {
          item.total = data[item.code].total;
          item.count = data[item.code].count;
        });
        this.setState({ config: role });
      }
    });
  }

  //获取待审批任务数量
  getStayTasksApprovedNum() {
    let postbody = {
      companyCode: this.companyCode,
      apiPath: '/workflowBills/order/getStayTasksApprovedNum',
    };
    Http.post('/api/cloudCenter', postbody).then(response => {
      if (response.success) {
        this.setState({ approvedNum: response.data || 0 });
      }
    });
  }

  async handleCompanyChange(companyCode) {
    this.companyCode = companyCode;
    //检查IP登录限制
    User.checkIpLimit(companyCode);
    //切企业后，延迟处理菜单
    setTimeout(() => {
      let shortcuts = this.updateShortcuts(this.state.shortcuts);
      this.setState({ shortcuts: shortcuts });
      this.getMpMenuList();
    }, 100);
  }

  handleModalChange(data) {
    if (data === 'success') {
      this.setState({ showToast: true });
      setTimeout(() => {
        window.location.reload();
      }, 3000);
    }
  }

  setDrawerMenu(isShow) {
    this.setState({ showDrawerMenu: isShow });
  }

  render() {
    const { classes } = this.props;
    if (this.state.error !== null) {
      //return <Msg {...this.state.error} />;
      return <Redirect to="/mp/index" />;
    }

    return !this.state.inited ? (
      ''
    ) : (
      <div>
        <div className="wrap m-header-bar clearfix">
          <IconButton
            className={classes.menuButton}
            color="inherit"
            aria-label="Menu"
            onClick={() => {
              this.setDrawerMenu(true);
            }}
          >
            <MenuIcon />
          </IconButton>
          <Company onChange={this.handleCompanyChange} />
        </div>

        <div className="m-card-wrap">
          <div className="wrap-body">
            <div className="banner"></div>
          </div>
        </div>

        <div className="m-card-wrap">
          <div className="wrap-body">
            {/* 待办 */}
            <div className="flex-wrap pending">
              <Link to="/mp/pending/list/1" className="flex-item">
                <p>待处理</p>
                <p>
                  {this.pendingConfigJson[1] && (
                    <b>{this.state.waitWorksCount}</b>
                  )}
                  {!this.pendingConfigJson[1] && <b>--</b>}
                </p>
              </Link>
              <Link to="/mp/pending/list/2" className="flex-item">
                <p>待跟进</p>
                <p>
                  {this.pendingConfigJson[2] && (
                    <b>{this.state.waitFollowCount}</b>
                  )}
                  {!this.pendingConfigJson[2] && <b>--</b>}
                </p>
              </Link>
              <Link
                to="/mp/management/workflow/approve/list"
                className="flex-item"
              >
                <p>待审批</p>
                <p>
                  {this.pendingConfigJson[3] && <b>{this.state.approvedNum}</b>}
                  {!this.pendingConfigJson[3] && <b>--</b>}
                </p>
              </Link>
            </div>
            {/* 常用功能 */}
            {this.state.shortcuts.length > 0 && (
              <div
                className={`flex-wrap shortcut ${
                  this.state.open ? 'open' : ''
                }`}
              >
                {this.state.shortcuts.map((item, index) => (
                  <div key={index} className="flex-item">
                    {(User.checkAuth(item.authCode) || !item.authCode) &&
                    item.path ? (
                      <Link to={item.path} className="flex-item-into">
                        <span className="img">
                          <img src={item.icon}></img>
                        </span>
                        <p className="clamp">{item.menuName}</p>
                      </Link>
                    ) : (
                      <div
                        className="flex-item-into"
                        onClick={() => this.handleShortcutClick(item)}
                      >
                        <span className="img">
                          <img src={item.icon}></img>
                        </span>
                        <p className="clamp">{item.menuName}</p>
                      </div>
                    )}
                  </div>
                ))}
              </div>
            )}

            <div
              className={`btm-on-off ${this.state.open ? 'open' : ''}`}
              onClick={() => this.handleOnOff()}
            >
              <i className="icon-up-2"></i>
            </div>
          </div>
        </div>

        <div className="m-card-wrap tab">
          <div className={`wrap-header ${this.state.menuSort ? 'edit' : ''}`}>
            <div className="header-main">
              <ul className="tab-box">
                <li
                  className={`tab-item ${
                    this.state.roleType === 1 ? 'curr' : ''
                  }`}
                  onClick={() => this.handleTab(1)}
                >
                  采购方
                </li>
                <li
                  className={`tab-item ${
                    this.state.roleType === 2 ? 'curr' : ''
                  }`}
                  onClick={() => this.handleTab(2)}
                >
                  供应商
                </li>
              </ul>
            </div>
            <div className="header-more" onClick={() => this.handleSort()}>
              <span className="sort"></span>
            </div>
          </div>
        </div>

        <div className="drag-drop-wrap">
          {this.state.mpMenuList.map((item, index) => (
            <div key={index} className="drag-elements m-card-wrap">
              <div className="wrap-header">
                <div className="header-main">
                  <b>{item.menuName}</b>
                </div>
                {!this.state.menuSort ? (
                  <div
                    className={`header-more ${item.isOn ? 'open' : ''}`}
                    onClick={() => this.handleMore(item)}
                  >
                    <i className="icon-up-2"></i>
                  </div>
                ) : (
                  <div className="header-more">
                    <span className="sort"></span>
                  </div>
                )}
              </div>
              {item.isOn && !this.state.menuSort && (
                <div className="wrap-body">
                  <div className="flex-wrap sub-menu-list">
                    {item.subMenuList.map((row, idx) => (
                      <div
                        key={String(index) + idx}
                        className="flex-item sub-menu-item"
                      >
                        {row.sort !== 99999 ? (
                          <Link to={row.path} className="sub-menu-into">
                            <span className="img">
                              <img src={row.icon}></img>
                            </span>
                            <p className="clamp">{row.menuName}</p>
                            {row.menuMark && <sup></sup>}
                          </Link>
                        ) : (
                          <div className="sub-menu-into">
                            <span className="img">
                              <img className="grayscale" src={row.icon}></img>
                            </span>
                            <p className="clamp">{row.menuName}</p>
                          </div>
                        )}
                      </div>
                    ))}
                  </div>
                </div>
              )}
            </div>
          ))}
        </div>

        {this.state.menuSort && (
          <div className="sort-update fixed-bottom w100">
            <span
              className="m-flex-item u-btn u-btn_line"
              onClick={() => this.handleSortUpdate()}
            >
              取消
            </span>
            <span
              className="m-flex-item u-btn u-btn_primary"
              onClick={() => this.handleSortUpdate('save')}
            >
              保存
            </span>
          </div>
        )}

        {/* <div className="gridBox gridBox-2">
          <h4>统计数据</h4>
          <div className="gridList clearfix">
            {this.state.config.items.map(item => (
              <div className="gridItem" key={item.code}>
                <div className="text-2">{item.count} / {item.total}</div>
                <div className="text">{item.label}</div>
              </div>
            ))}
          </div>
        </div> */}

        {/* <div className="gridBox">
          <h4>常用功能</h4>
          <div className="gridList clearfix">
            {shortcutRoutes.map((route, index) => (
              <div key={index}>
                {(User.checkAuth(route.authCode) || route.authCode === '') &&
                route.path ? (
                  <Link to={route.path} className="gridItem">
                    <div className={`icon icon-${index}`}>{route.icon}</div>
                    <div className="text">{route.text}</div>
                    {route.menuMark && <sup></sup>}
                  </Link>
                ) : (
                  <div
                    className="gridItem"
                    onClick={() => this.handleShortcutClick(route)}
                  >
                    <div className={`icon icon-${index}`}>{route.icon}</div>
                    <div className="text">{route.text}</div>
                  </div>
                )}
              </div>
            ))}
            {Public.isWeWork && this.state.isDebug && (
              <Link to="/mp/wWwxCoprGroup" className="gridItem">
                <div className="icon icon-1">
                  <PeopleIcon color="primary" fontSize="inherit" />
                </div>
                <div className="text">上下游</div>
              </Link>
            )}
          </div>
        </div> */}

        {/* <div className="gridBox">
          <h4>采购协同</h4>
          <div className="gridList clearfix">
            {purchsRoutes.map((route, index) => (
              <div key={index}>
                {User.checkAuth(route.authCode) ? (
                  <Link to={route.path} className="gridItem">
                    <div className={`icon icon-${index}`}>{route.icon}</div>
                    <div className="text">{route.text}</div>
                    {route.menuMark && <sup></sup>}
                  </Link>
                ) : (
                  <div className="gridItem">
                    <div className="icon">{route.icon}</div>
                    <div className="text">{route.text}</div>
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>

        <div className="gridBox">
          <h4>销售协同</h4>
          <div className="gridList clearfix">
            {saleRoutes.map((route, index) => (
              <div key={index}>
                {User.checkAuth(route.authCode) ? (
                  <Link to={route.path} className="gridItem">
                    <div className={`icon icon-${index}`}>{route.icon}</div>
                    <div className="text">{route.text}</div>
                    {route.menuMark && <sup></sup>}
                  </Link>
                ) : (
                  <div className="gridItem">
                    <div className="icon">{route.icon}</div>
                    <div className="text">{route.text}</div>
                  </div>
                )}
              </div>
            ))}
          </div>
        </div> */}

        {/* <div className="gridBox">
          <h4>配置管理</h4>
          <div className="gridList clearfix">
            {managementRoutes.map((route, index) => (
              <div key={index}>
                {User.checkAuth(route.authCode) ? (
                  <Link to={route.path} className="gridItem">
                    <div className={`icon icon-${index}`}>{route.icon}</div>
                    <div className="text">{route.text}</div>
                    {route.menuMark && <sup></sup>}
                  </Link>
                ) : (
                  <div className="gridItem">
                    <div className="icon">{route.icon}</div>
                    <div className="text">{route.text}</div>
                  </div>
                )}
              </div>
            ))}
          </div>
        </div> */}
        <Dialog
          aria-labelledby="simple-dialog-title"
          open={this.state.showRoleSetup}
        >
          <DialogTitle id="simple-dialog-title">设置初始角色</DialogTitle>
          <div>
            <List>
              <ListItem
                button
                onClick={() => this.handleRole(1)}
                className={classes.listItem}
              >
                <ListItemAvatar>
                  <Avatar className={classes.avatar}>
                    <PersonIcon />
                  </Avatar>
                </ListItemAvatar>
                <ListItemText primary="我是采购商" />
              </ListItem>

              <ListItem
                button
                onClick={() => this.handleRole(2)}
                className={classes.listItem}
              >
                <ListItemAvatar>
                  <Avatar className={classes.avatar}>
                    <PersonIcon />
                  </Avatar>
                </ListItemAvatar>
                <ListItemText primary="我是供应商" />
              </ListItem>
            </List>
          </div>
        </Dialog>

        <VerifyPartner onChange={this.handleModalChange} />
        <EmployeeJoin onChange={this.handleModalChange} />

        <Toast icon="success-no-circle" show={this.state.showToast}>
          完成
        </Toast>
        <Toast icon="warn" show={this.state.showError}>
          {this.errorMsg}
        </Toast>
        <Toast icon="loading" show={this.state.showLoading}>
          Loading...
        </Toast>
        <Toast icon="success-no-circle" show={this.state.showSuccess}>
          操作成功
        </Toast>
        <Drawer
          open={this.state.showDrawerMenu}
          onClose={() => {
            this.setDrawerMenu(false);
          }}
        >
          <div
            tabIndex={0}
            role="button"
            onClick={() => {
              this.setDrawerMenu(false);
            }}
            onKeyDown={() => {
              this.setDrawerMenu(false);
            }}
          >
            {drawerList}
          </div>
        </Drawer>
      </div>
    );
  }
}

WorkBench.propTypes = {
  classes: PropTypes.object.isRequired,
  data: PropTypes.object.isRequired,
  actions: PropTypes.object.isRequired,
};

const mapStateToProps = state => {
  return {
    data: state.modal,
  };
};

const mapDispatchToProps = dispatch => {
  return {
    actions: bindActionCreators(MobileActions, dispatch),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(styles)(WorkBench));
